import {
  CodeOutlined,
  FileTextOutlined,
  FormOutlined,
  SafetyCertificateOutlined,
  UserOutlined,
  MailOutlined,
} from '@ant-design/icons';
import { SuperAdminIcon } from 'src/icons';
import { frontdeskNavMenus } from 'src/pages';

const SuperAdminSideMenu = ({ isActive, isFrontdeskModuleEntitled }) => {
  return [
    {
      path: '/superadmin',
      title: 'Super Admin',
      icon: <SuperAdminIcon isFilled={isActive} />,
      submenu: [
        {
          path: '/csvupload',
          title: 'CSV Upload',
          icon: <FileTextOutlined />,
        },
        {
          path: '/sr-upload',
          title: 'Service Request',
          icon: <MailOutlined />,
        },
        {
          path: '/ai',
          title: 'AI',
          icon: <CodeOutlined />,
        },
        {
          path: '/agents',
          title: 'Agents',
          icon: <UserOutlined />,
        },
        {
          path: '/formconditions',
          title: 'Form Conditions',
          icon: <FormOutlined />,
        },
        {
          path: '/templates',
          title: 'Templates',
          icon: <FileTextOutlined />,
        },
        {
          path: '/superadmin/officepracticum',
          title: 'Office Practicum',
          icon: (
            <img
              src="https://images.insighthealth.ai/office-practicum/logo.svg"
              alt="Office Practicum Logo"
              width={20}
              height={20}
              className="mr-[-4px]"
            />
          ),
        },
        ...(isFrontdeskModuleEntitled
          ? frontdeskNavMenus?.[0]?.submenu || []
          : []),
      ],
    },
    {
      title: 'Care AI',
      icon: <SafetyCertificateOutlined />,
    },
  ];
};

export default SuperAdminSideMenu;
